<script setup lang="ts">
import type { SlugHeaderContentProps } from '.';

defineProps<SlugHeaderContentProps>();
</script>

<template>
  <PageContainerAlignment class="gap-r18 flex pb-36 text-black max-lg:hidden">
    <div class="pt-r18 gap-r18 flex max-w-3/5 flex-col justify-between">
      <div class="flex-1">
        <div
          class="gap-r12 sticky top-[calc(var(--navbar-height)+var(--spacing-r18))] flex flex-col"
        >
          <div class="gap-r8 flex flex-col">
            <AppHeading
              tag="h2"
              size="custom"
              class="text-client-orange text-[32px] font-extrabold"
            >
              {{ subtitle }}
            </AppHeading>
            <AppHeading tag="h1" size="custom" class="text-7xl font-extrabold!">
              {{ title }}
            </AppHeading>
          </div>

          <div class="gap-r8 flex items-center">
            <AppLink
              v-for="(link, i) in links"
              :key="i"
              type="custom"
              :to="link.to"
              :opts="{ link: { external: true, target: '_blank' } }"
              class="text-client-orange gap-r2 inline-flex items-center uppercase underline underline-offset-2"
            >
              <AppIcon v-if="link.icon" :name="link.icon" size="md" />
              <AppText size="lg">{{ link.label }}</AppText>
            </AppLink>
          </div>
        </div>
      </div>

      <AppParagraph class="font-medium!">
        {{ description }}
      </AppParagraph>
    </div>

    <div
      class="relative aspect-3/4 w-full max-w-2/5 overflow-hidden rounded-lg max-[2561px]:min-h-screen"
    >
      <div
        style="
          background: linear-gradient(
            232.13deg,
            #000000 0%,
            rgba(0, 0, 0, 0) 47.66%
          );
        "
        class="absolute top-0 right-0 aspect-square w-3/4 xl:w-1/2"
      >
        <AppIcon
          :name="icon"
          size="custom"
          class="top-r5 right-r5 absolute size-24 drop-shadow-xl drop-shadow-black"
        />
      </div>
      <img
        :src="imageHeader.url"
        :alt="imageHeader.alt"
        class="size-full object-cover"
      />
    </div>
  </PageContainerAlignment>
</template>
